module.exports = __webpack_public_path__ + "static/media/mouthSmileRight.13a1fc70.obj";